import React from 'react';
import { STATUS_COLORS } from '../constants';

const TemplateListPanel = ({
  rows,
  loading,
  selectedId,
  createForm,
  setCreateForm,
  onCreate,
  onOpen,
  onClone,
  onCreateVersion,
  onValidate,
  onPreview,
  onPublish,
  draft,
}) => (
  <div className="panel ra-tpl-list-panel">
    <div className="ra-tpl-list-panel__head">
      <h4>Templates</h4>
      <span className="count-badge">{rows.length}</span>
    </div>

    <div className="ra-tpl-create-mini">
      <div className="form-group">
        <label>New template name</label>
        <input
          value={createForm.name}
          onChange={(e) => setCreateForm((p) => ({ ...p, name: e.target.value }))}
          placeholder="Railways RA Bill"
        />
      </div>
      <div className="form-group">
        <label>Code</label>
        <input
          value={createForm.code}
          onChange={(e) => setCreateForm((p) => ({ ...p, code: e.target.value }))}
          placeholder="RAILWAYS_RA"
        />
      </div>
      <div className="form-group">
        <label>Engine</label>
        <select
          value={createForm.calculationEngine}
          onChange={(e) => setCreateForm((p) => ({ ...p, calculationEngine: e.target.value }))}
        >
          <option value="CONFIGURABLE">Configurable (visual rules)</option>
          <option value="LEGACY_CPWD">Legacy CPWD</option>
        </select>
      </div>
      <button type="button" className="btn-primary btn-sm" onClick={onCreate}>Create Template</button>
    </div>

    <div className="ra-tpl-list-scroll">
      {loading ? (
        <p className="ra-template-empty">Loading…</p>
      ) : rows.length === 0 ? (
        <p className="ra-template-empty">No templates yet.</p>
      ) : rows.map((r) => {
        const active = selectedId === r.id;
        return (
          <div
            key={r.id}
            className={`ra-tpl-list-item ${active ? 'is-active' : ''}`}
            onClick={() => onOpen(r.id)}
          >
            <div className="ra-tpl-list-item__title">
              <strong>{r.name}</strong>
              <span
                className="ra-tpl-status-badge"
                style={{ background: `${STATUS_COLORS[r.status] || '#64748b'}22`, color: STATUS_COLORS[r.status] || '#64748b' }}
              >
                {r.status}
              </span>
            </div>
            <div className="ra-tpl-list-item__meta">
              <span>{r.code}</span>
              <span>v{r.version}</span>
              <span>{r.department?.code || r.department?.name || '—'}</span>
              <span>{r.calculationEngine === 'LEGACY_CPWD' ? 'CPWD' : 'Configurable'}</span>
            </div>
            <div className="ra-tpl-list-item__actions" onClick={(e) => e.stopPropagation()}>
              <button type="button" className="btn-secondary btn-sm" onClick={() => onOpen(r.id)}>Open</button>
              <button type="button" className="btn-secondary btn-sm" onClick={() => onClone(r)}>Clone</button>
              <button type="button" className="btn-secondary btn-sm" onClick={() => onCreateVersion(r.id)}>New version</button>
            </div>
          </div>
        );
      })}
    </div>

    {draft && (
      <div className="ra-tpl-list-workflow">
        <p className="ra-tpl-workflow-label">Workflow</p>
        <ol className="ra-tpl-workflow-steps">
          <li>Configure</li>
          <li>Validate</li>
          <li>Test</li>
          <li>Publish</li>
        </ol>
        <div className="ra-tpl-list-item__actions">
          <button type="button" className="btn-secondary btn-sm" onClick={onValidate}>Validate</button>
          <button type="button" className="btn-secondary btn-sm" onClick={onPreview}>Preview</button>
          <button type="button" className="btn-primary btn-sm" onClick={onPublish}>Publish</button>
        </div>
      </div>
    )}
  </div>
);

export default TemplateListPanel;
